import React from 'react';
import { Link } from 'react-router-dom';
import fonImage from '../assets/fon.webp';

const Hero = () => {
  const heroStyle = {
    background: `linear-gradient(rgba(235, 229, 229, 0.5), rgba(240, 238, 238, 0.3)), url(${fonImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: 'var(--white)',
    textAlign: 'center',
    padding: '100px 20px',
    marginBottom: '40px'
  };

  return (
    <section className="hero" id="home" style={heroStyle}>
      <div className="container">
        <h2>За достойную жизнь и социальную справедливость!</h2>
        <p className="slogon" style={{ color: 'var(--dark)', fontWeight: 700, fontSize: '24px' }}>
          Нефтеюганское городское отделение КПРФ ведет последовательную борьбу за права трудящихся и возрождение реального народовластия.
        </p>
        <Link to="/howtojoin" className="btn">
          Присоединиться к борьбе
        </Link>
      </div>
    </section>
  );
};

export default Hero;